import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { ORDERS_SLICE_NAME, OrdersState } from './models';

export const ordersSelector = (state: RootState): OrdersState => state[ORDERS_SLICE_NAME];

export const selectQuery = createSelector(ordersSelector, (state: OrdersState) => state.query);

export const selectAutoCompleteNovaPoshtas = createSelector(
  ordersSelector,
  (state: OrdersState) => state.novaPoshtaDepartments,
);

export const selectNewOrdersCount = createSelector(ordersSelector, (state: OrdersState) => state.newCount);
